import React from 'react';

const Footer = () => {
    return (
        <footer>Copyright<br /><br />Richard Seward 2022</footer>
    );
};

export default Footer;